<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div *ngIf="data.title" class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ data.title }}</h3>
    </div>
  </div>
  <div style="min-height: 200px !important" class="card-body pt-15">
    <div class="card-body-progress">
      <mat-spinner [diameter]="5"></mat-spinner>
    </div>
    <div [innerHtml]="(viewLoading ? data.waitDesciption : data.description) | safe : 'html'"></div>
  </div>
  <div
    tabindex="0"
    class="card-footer d-flex justify-content-end"
    (keydown.enter)="onEnterKey($event)"
  >
    <button
      #cancelButton
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="onNoClick()"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      #confirmButton
      *ngIf="!data.hideConfirmBtn"
      mat-raised-button
      [disabled]="viewLoading"
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="onYesClick()"
    >
      {{ 'GLOBAL.CONFIRM' | translate }}
    </button>
  </div>
</div>
